import $http from "../../axios";
import { Notification } from "element-ui";

export async function getDocumentTransactions({commit, state, dispatch}, params){
  await $http.get(`/api/proyect-transactions/${params.projectId}`, {params})
  .then(response => {
    commit('setTransactions', response.data.data);
  })
  .catch(error => {
    // let data = error.response.data
    Notification.error({
      title: "Error!",
      message: 'error',
      type: "error",
      duration: 1500,
      customClass: "notification-box"
    });
  });
  state.loading.transactions = false;
}
//Obtener los marcas
export async function fetchProjects(
  { commit, state },
  paramsData = {}
) {
  let requestParameters = {
    params: {
      paginate: false,
      ...paramsData
    }
  };
  await $http
    .get("/api/proyectos", requestParameters)
    .then(response => {
      if (requestParameters.params.paginate) {
        commit("setProjectsTable", response.data.data);
      } else {
        commit("setProjects", response.data.data);
      }
    })
    .catch(error => {
      console.error(error);
      Notification.error({
        title: "Error!",
        message: error.message,
        type: "error",
        duration: 1500,
        customClass: "notification-box"
      });
    });
}



// WEBPACK FOOTER //
// ./src/modules/project-movements/actions.js